<template>
    <div>
        <p v-if="Loading" style="text-align: center;height: 390px;line-height: 390px;"><mt-spinner type="triple-bounce"></mt-spinner></p>
        <div class="block">
            <el-carousel height="392px">
                <el-carousel-item class="shufflingPic" v-for="(item,index) in shufflingFunList" :key="item.id" @click.native="shufflingPicFun(item)">
                    <span class="shufflingPicTitle">{{item.title}}</span>
                    <img style="width:100%" :src="item.image_url" alt="">
                    <!-- <el-image style="width:100%" :src="item.image_url" lazy></el-image> -->
                </el-carousel-item>
            </el-carousel>
        </div>
    </div>
</template>
<script>
import {listApi,generateSign} from '@/api/index'
import Bus from '@/Bus'
const shufflingParameter = {
    pageNum: 0,
    pageSize: 10,
    columnId: "5cc57db80cf2c3d1b7e9d4e1",
    userId: "",
    appInfoId: "10"
}
const getNewsColumnData = {
    pageNum: 0,
    pageSize: 10,
    columnId: "5d68ce5de4b0e2963a408843",
    userId: "",
    appInfoId: "10"
}
export default {
    data(){
        return {
            Loading:true,
            jumpRouting:true,
            shuParameter: Object.assign({}, shufflingParameter),
            getColumnData: Object.assign({}, getNewsColumnData),
            shufflingFunList:null,
            shufflingPicture:[]
        }
    },
    created(){
        this.shufflingFun()
    },
    methods:{
        async shufflingFun(){
            const headers = { 
        'Sign': generateSign()
      };
            const res = await this.axios.post(listApi,this.shuParameter,{ headers })
            this.shufflingFunList = res.data.data[0].list.splice(0,5)
            this.Loading = false
        },
        shufflingPicFun(type){
            let routeData = this.$router.resolve({ path: '/details', query: {  id: type.id,jsonUrl:type.jsonUrl } });
            window.open(routeData.href, '_blank');
            Bus.$emit('jumpRouting', false );
        }
    }
}
</script>
<style lang="">
   .el-carousel__item h3{
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 392px;
    margin: 0;
  }
  .shufflingPic{
    cursor:pointer; 
  }
  .shufflingPic .shufflingPicTitle{
    cursor:pointer; 
    position:absolute;
    bottom:0;
    width:100%;
    height:72px;
    background:rgba(0,0,0,0.5);
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    color:#FFFFFF;
    text-align: center;
    line-height:50px;
  } 
</style>


// WEBPACK FOOTER //
// src/components/homepage/components/shufflingImg.vue